import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ValidationFailureTypesApi } from '../services';

type Params = Parameters<InstanceType<typeof ValidationFailureTypesApi>['getValidationFailureType']>[0];
type QueryOptions = Pick<UseQueryOptions, 'enabled'>;

export function useGetValidationFailureType(params: Params, queryOptions?: QueryOptions) {
    const query = useQuery({
        queryKey: ['/ValidationFailureType', params],
        queryFn: async () => {
            const vftApi = new ValidationFailureTypesApi();

            const resp = await vftApi.getValidationFailureType(params);

            return resp.data;
        },
        staleTime: Infinity,
        cacheTime: Infinity,
        ...queryOptions,
    });

    return query;
}
